import apiHandler from "../core/apiHandler";

const purchaseApi = apiHandler('purchases');
export default purchaseApi;
